export default __webpack_public_path__ + "static/media/people2full.e082d24f.jpg";